import Button from "antd/es/button";
import Checkbox from "antd/es/checkbox";
import Flex from "antd/es/flex";
import Form from "antd/es/form";
import Input from "antd/es/input";
import Modal from "antd/es/modal";
import Select from "antd/es/select";
import Table from "antd/es/table";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  BlockedDriver } from "src/redux/actions/DriverAttenAction";
import CustomTableLoader from "../common/CustomTableLoader";

export const Inactivemodel = (props: any) => {
  const {
    isInactiveModalVisible,
    setInactiveModalVisible,
    selectedRows,
    setSelectedRows,
  } = props;
  const [reason, setReason] = useState("");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const [searchText, setSearchText] = useState<string>("");
  const DriverAttenData = useSelector(
    (state: any) => state.driverAtten?.blockdata || {}
  );
  const loading = useSelector((state: any) => state.driverAtten.loading);
  const dispatch = useDispatch();

  const REASON_OPTIONS = [
    { value: "Pending Payment", label: "Pending Payment" },
    { value: "Uniform", label: "Uniform" },
    { value: "Sticker", label: "Sticker" },
    { value: "Misbehaving", label: "Misbehaving" },
    { value: "Not Taking Trips", label: "Not Taking Trips" },
    { value: "Time Management", label: "Time Management" },
    { value: "Others", label: "Others" },
  ];
  const inactiveColumns = [
    {
      title: "",
      dataIndex: "checkbox",
      render: (_: any, record: any) => {
        const isChecked = selectedRows.some(
          (row: any) => row.cabid === record.cabid
        );

        return (
          <Checkbox
            checked={isChecked}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedRows([...selectedRows, record]);
              } else {
                setSelectedRows(
                  selectedRows.filter((row: any) => row.cabid !== record.cabid)
                );
              }
            }}
          />
        );
      },
      width: 50,
    },
    {
      title: "Cab ID",
      dataIndex: "cabid",
      key: "cabid",
    },
    {
      title: "Owner Name",
      dataIndex: "ownername",
      key: "ownername",
    },
    {
      title: "Driver Status",
      dataIndex: "driverstatus",
      key: "driverstatus",
    },
  ];

  const getSelectedStatusCode = () => {
    const uniqueStatusCodes = new Set(
      selectedRows.map((row: any) => row.statuscode)
    );
    if (uniqueStatusCodes.size === 1) {
      return selectedRows[0]?.statuscode;
    }
    return null;
  };

  const BLOCKABLE_CODES = [1, 5, 10, 11, 13, 14, 15, 17, 19];
  const UNBLOCKABLE_CODE = 16;
  const statusCode = getSelectedStatusCode();

  const handleInactiveClick = () => {
    const payload = selectedRows.map((row: any) => ({
      cabid: row.cabid,
      reason: reason,
      mobileno: row.mobileno,
      name: row.drivername,
      ownername: row.ownername,
      ownermobileno: row.ownermobile,
      blockedBy: userData.employeename,
    }));

    dispatch(BlockedDriver(payload));
    setSelectedRows([]);
    setReason("");
    setInactiveModalVisible(false);
  };
  const { data: cabid = [] } = DriverAttenData || {};

  const filteredDataSource = cabid.filter((record: any) => {
    const cabId = (record.cabid || "").toString().toLowerCase();
    return cabId.includes(searchText.toLowerCase());
  });

  const handleActiveClick = () => {
    const payload = selectedRows.map((row: any) => ({
      cabid: row.cabid,
      unblockedBy: userData.employeename,
    }));

    // dispatch(ActiveDriver(payload));
    setSelectedRows([]);
    setReason("");
    setInactiveModalVisible(false);
  };

  return (
    <Modal
      open={isInactiveModalVisible}
      onCancel={() => setInactiveModalVisible(false)}
      footer={null}
      // closable={false}
      width={750}
      centered
      title={
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
            color: "white",
            background: "purple",
          }}
        >
          Inactive Driver Form
        </div>
      }
    >
      <br />
      <div
        style={{
          display: "flex",
          width: "100%",
        }}
      >
        <div style={{ width: "60%", gap: "3%", display:'flex' }}>
          {BLOCKABLE_CODES.includes(statusCode) && (
            <Form.Item
              name="reason"
              rules={[{ required: true, message: "Please select a reason" }]}
              style={{ width: "45%" }}
            >
              <Select
                placeholder="Select reason"
                allowClear
                options={REASON_OPTIONS}
                value={reason}
                onChange={(v) => setReason(v)}
                disabled={selectedRows.length === 0}
              />
            </Form.Item>
          )}
          {/* <Button type="primary" danger onClick={handleInactiveClick}>
            Inactive
          </Button> */}
          {(() => {
            const statusCode = getSelectedStatusCode();
            if (BLOCKABLE_CODES.includes(statusCode)) {
              return (
                <Button
                  type="primary"
                  danger
                  onClick={handleInactiveClick}
                  disabled={selectedRows.length === 0 || !reason}
                >
                  Inactive
                </Button>
              );
            } else if (statusCode === UNBLOCKABLE_CODE) {
              return (
                <Button type="primary" onClick={handleActiveClick}>
                  Active
                </Button>
              );
            } else {
              return null;
            }
          })()}
        </div>
        <div style={{ width: "40%", display:'flex', justifyContent: "end" }}>
          <Input.Search
            placeholder="Search Cab ID"
            allowClear
            style={{ width: "60%" }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <br />
      <Table
        loading={{
          spinning: loading,
          indicator: <CustomTableLoader />,
        }}
        columns={inactiveColumns}
        dataSource={filteredDataSource}
        rowKey="cabId"
        bordered
        size="large"
      />
    </Modal>
  );
};
